import {
  ValidarLimiteSimulacao,
  ListarSimulacoes,
  ListarExames,
  ListarLaboratorios,
  IncluirSimulacao
} from "@/api/coverageAnalysis";
import Vue from "vue";

const initalState = {
  searchExams: [],
  searchLabs: [],
  selectedExams: [],
  simulations: [],
  authorized: false,
  labsFromFinish: false
};

export default {
  namespaced: true,
  state: () => ({ ...initalState }),
  getters: {
    hasRequiresAuthorization: state => {
      return state.selectedExams.some(exam => exam.ExigeAutorizacao === true);
    },
    hasExamNotFound: state => {
      return state.selectedExams.some(exam => exam.NaoEncontrado === true || !exam.CodigoExame);
    }
  },
  actions: {
    async validateLimit(context) {
      try {
        const resp = await ValidarLimiteSimulacao({
          vinculo: context.rootState.saude.vinculo
        });
        context.commit("SET_AUTHORIZED", resp?.Data?.Autorizado ?? false);
      } catch {
        context.commit("SET_AUTHORIZED", false);
        return false;
      }
    },
    async fetchExams(context, { search }) {
      if (search?.leght === 0) {
        context.commit("SET_SEARCH_EXAMS", []);
        return;
      }

      const resp =
        (
          await ListarExames({
            vinculo: context.rootState.saude.vinculo,
            exame: search
          })
        )?.Data ?? [];

      const exams = resp.length
        ? resp.map(e => ({
            ...e,
            selected: context.state.selectedExams.some(
              selectedExam => selectedExam.CodigoExame === e.CodigoExame && selectedExam.Descricao === e.Descricao
            )
          }))
        : [
            {
              CodigoExame: "",
              Descricao: search,
              PossuiCobertura: false,
              ExigeAutorizacao: false,
              selected: context.state.selectedExams.some(
                selectedExam => selectedExam.CodigoExame === "" && selectedExam.Descricao === search
              )
            }
          ];

      context.commit("SET_SEARCH_EXAMS", exams);
    },
    async fetchSimulations(context) {
      try {
        const resp = await ListarSimulacoes({
          vinculo: context.rootState.saude.vinculo
        });
        context.commit("SET_SIMULATIONS", resp.Data);
        return true;
      } catch {
        return false;
      }
    },
    async fetchLaboratoriess(context, { prestador, idSimulacao }) {
      if (context.state.labsFromFinish) {
        context.commit("SET_LABS_FROM_FINISH", false);
        return;
      }

      try {
        const resp = (
          await ListarLaboratorios({
            vinculo: context.rootState.saude.vinculo,
            prestador,
            idSimulacao
          })
        ).Data;
        context.commit("SET_SEARCH_LABS", resp);
        return resp;
      } catch {
        context.commit("SET_SEARCH_LABS", []);
        return "";
      }
    },
    selectExam(context, { CodigoExame, Descricao, value }) {
      context.commit("TOGGLE_SELECTED_EXAM", { CodigoExame, Descricao, value });
    },
    clearSelectedExams(context) {
      context.state.selectedExams.map(e =>
        context.dispatch("selectExam", { CodigoExame: e.CodigoExame, Descricao: e.Descricao, value: false })
      );
    },
    async finishSimulation(context, { obterLaboratorios }) {
      const resp = (
        await IncluirSimulacao({
          vinculo: context.rootState.saude.vinculo,
          exames: context.state.selectedExams,
          obterLaboratorios
        })
      ).Data;

      if (obterLaboratorios) {
        context.commit("SET_SEARCH_LABS", resp.Laboratorios);
        context.commit("SET_LABS_FROM_FINISH", true);
      }
      return resp.IdSimulacao;
    }
  },
  mutations: {
    LOGOUT_USER: state => Object.keys(state).forEach(p => Vue.set(state, p, initalState[p])),
    RESET_CONTEXT: state => Object.keys(state).forEach(p => Vue.set(state, p, initalState[p])),
    SET_SEARCH_EXAMS: (state, exams) => Vue.set(state, "searchExams", exams),
    SET_SEARCH_LABS: (state, exams) => Vue.set(state, "searchLabs", exams),
    SET_SELECTED_EXAMS: (state, exams) => Vue.set(state, "selectedExams", exams),
    SET_SIMULATIONS: (state, simulations) => Vue.set(state, "simulations", simulations),
    SET_AUTHORIZED: (state, authorized) => Vue.set(state, "authorized", authorized),
    SET_LABS_FROM_FINISH: (state, labsFromFinish) => Vue.set(state, "labsFromFinish", labsFromFinish),
    TOGGLE_SELECTED_EXAM: (state, { CodigoExame, Descricao, value }) => {
      const isSameExam = exam => exam.CodigoExame === CodigoExame && exam.Descricao === Descricao;
      Vue.set(
        state,
        "searchExams",
        state.searchExams.map(exam => ({
          ...exam,
          selected: isSameExam(exam) ? value : exam.selected
        }))
      );

      if (value) {
        const alreadySelected = state.selectedExams.some(isSameExam);
        if (!alreadySelected) {
          const selectedExam = state.searchExams.find(isSameExam);
          if (selectedExam) {
            Vue.set(state.selectedExams, state.selectedExams.length, selectedExam);
          }
        }
      } else {
        const updatedSelectedExams = state.selectedExams.filter(exam => !isSameExam(exam));
        Vue.set(state, "selectedExams", updatedSelectedExams);
      }
    }
  }
};
